import styles from '../styles/Modal.module.css'

export default function Modal(props) {
  return (
    <div
      className={props.show ? styles.backdrop : [styles.hide, styles.backdrop].join(' ')}
      onClick={props.showModalToggler}
    >
      <div className={styles.modal}>
        <div className={styles.stripe}>
          <h1>Error</h1>
          <div className={styles.close} onClick={props.showModalToggler}>
            <img style={{height: '20px', width: '20px'}}src="/plus.svg" alt={props.show ? "expand" : "close"}/>
          </div>
        </div>
        <div className={styles.content}>
          <h3>{props.message}</h3>
          <p>Please try again later.</p>
        </div>
      </div>
    </div>
  )
}
